<template>

  <nav class="navbar-me" id="navbar">

    <div class="container">

      <div class="content">

        <div class="menu visible-mobile" @click="toggleSideBar" id="menu">

          <img :src="toggleImg" alt="" />

        </div>



        <!-- {{ route.path }} -->



        <form @submit.prevent="handleSearch" class="search-form" v-if="shouldShowSearch">
          <div class="middle-form relative-parent search-main">
            <input 
              type="text" 
              placeholder="ادخل كلمة البحث"
              class="main-input" 
              v-model="searchValue"
              @input="handleSearchInput"
            />
            <button type="submit" class="fl-bt">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </div>
        </form>



        <div class="left">

          <div class="not">

            <router-link to="/notificationsView"></router-link>

            <i class="fa-regular fa-bell"></i>

            <span class="number" v-if="notiCount">{{ notiCount }}</span>

          </div>



          <router-link to="/editProfile">

            <div class="account">

              <img class="img-account userImage" :src="userImg" alt="" />

              <div class="info">

                <span class="black userName">{{ userName }}</span>

              </div>

            </div>

          </router-link>



          <div class="d-flex align-items-center">

            <!--ar-->

            <div class="drop-header px-3 py-2 font15 pointer-click" v-if="showArbic == 'ar'">

              {{ $t('navbarView.arabic') }}

              <i class="fa-solid fa-chevron-down"></i>

              <div class="drop-down-lang">

                <ul>

                  <li @click="setArabic()">

                    <a href="#" class="activeLang">{{ $t('navbarView.arabic') }}</a>

                  </li>

                  <li @click="setEnglish()"><a href="#">English</a></li>

                </ul>

              </div>

            </div>

            <!--en-->

            <div class="drop-header px-3 py-2 font15 pointer-click" v-else>

              English

              <i class="fa-solid fa-chevron-down"></i>

              <div class="drop-down-lang">

                <ul>

                  <li @click="setEnglish()">

                    <a href="#" class="activeLang">English</a>

                  </li>

                  <li @click="setArabic()"><a href="#">اللغة العربية</a></li>

                </ul>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </nav>

</template>



<script setup>

// imports

import router from "@/router";

import { ref, onMounted, computed  } from "vue";

import axios from "axios";

import { useRoute } from "vue-router";

import store from "@/store";



// route

const route = useRoute();



// reactive states

const showArbic = ref("");

const toggleImg = ref(require("../../assets/imgs/noun_List_2946302.png"));

const userImg = ref('');



const userName = ref('');
const notiCount = ref(null);

// searchValue
const searchValue = ref('');

// computed properties
const currentSearchValue = computed(() => store.state.searchValue);
const shouldShowSearch = computed(() => {
  return route.path?.includes('buildingsView') || 
         route.path?.includes('ownersView') || 
         route.path?.includes('MaintenanceView') || 
         route.path?.includes('TechniciansView') ||
         route.path?.includes('managementOrders');
});

// search functions
const handleSearchInput = (event) => {
  const value = event.target.value;
  searchValue.value = value;
  const currentPage = getCurrentPage();
  store.dispatch('searchItems', { value, page: currentPage });
};

const handleSearch = () => {
  const currentPage = getCurrentPage();
  store.dispatch('searchItems', { value: searchValue.value, page: currentPage });
};

const getCurrentPage = () => {
  if (route.path?.includes('buildingsView')) return 'buildingsView';
  if (route.path?.includes('ownersView')) return 'ownersView';
  if (route.path?.includes('MaintenanceView')) return 'MaintenanceView';
  if (route.path?.includes('TechniciansView')) return 'TechniciansView';
  if (route.path?.includes('managementOrders')) return 'managementOrders';
  return '';
};






// get profile

const getProfile = async () => {

  try {

    const response = await axios.get("/manager/profile", {

      headers: {

        Authorization: `Bearer ${localStorage.getItem("token")}`,

      },

    });

    localStorage.setItem("userName", response.data.data.name);

    if (response.data.key == 'unauthenticated') {

      localStorage.removeItem('token');

      router.push('/loginView')

    }

  } catch (error) {

    console.log(error);

  }

};


const getNotiCount = async () => {

  try {

    const response = await axios.get("/count-notifications", {

      headers: {

        Authorization: `Bearer ${localStorage.getItem("token")}`,

      },

    });

    notiCount.value = response.data.data?.count;

  } catch (error) {

    console.log(error);

  }

};





// functions

function toggleSideBar() {

  document.querySelector(".main-sec").classList.toggle("active-main");

  document.querySelector(".navbar-me").classList.toggle("active-nav");

  document.querySelector(".sidebar").classList.toggle("active-side");

}

// change language and local

function setArabic() {

  localStorage.setItem("locale", "ar");

  localStorage.setItem("lang", "ar");

  setTimeout(() => {

    this.$i18n.locale = "ar";

  }, 3000);



  // this.showArbic = this.$i18n.locale;

  location.reload();

}



function setEnglish() {

  localStorage.setItem("locale", "en");

  localStorage.setItem("lang", "en");

  setTimeout(() => {

    this.$i18n.locale = "en";

  }, 3000);



  location.reload();

}



// lifecycle hooks
onMounted(() => {
  getNotiCount();
  showArbic.value = localStorage.getItem("locale");
  localStorage.setItem("lang", localStorage.getItem("locale"));
  if (localStorage.getItem("locale") === null) {
    localStorage.setItem("locale", "ar");
  }
  userImg.value = localStorage.getItem("userImage");
  userName.value = localStorage.getItem("userName");
  
  // Initialize search value from store if on search-enabled page
  if (shouldShowSearch.value) {
    searchValue.value = currentSearchValue.value;
  }
  
  if (localStorage.getItem("token") && !route.path?.includes('editProfile')) {
    getProfile();
  }
});

</script>
